$(() => {
  $('[data-count-tag-on-modal-close]').on('hidden.bs.modal', function() {
    $(`[data-bs-target="#${$(this).attr('id')}"]` ).find('.badge').text($($(this).find('input:checkbox:checked')).length || '');
  });
});